import React from 'react';

import * as styles from './sync-data-card.scss';

export const SyncDataCardDivider = () => <div className={styles.createMenuDivider} />;
